<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="alertSuccess"
            @delete-item="deleteType"
            @cancel="item = null"
        ></view-item>

        <list-items
            v-if="!item"
            title="Review Types"
            :items="checkoffTypes"
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" @click="item = {}"
                        >Add Type</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'CheckoffType',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    created() {
        this.$store.dispatch('roles/fetchAll')
    },
    computed: {
        checkoffTypes() {
            const types = this.$store.state.checkoffTypes.types
            console.log('types', types)
            return types
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('checkoffTypes/fetchAll')
        },

        showItem(id) {
            this.item = this.checkoffTypes.find(x => x.id === id)
        },

        alertSuccess(message) {
            this.doToast('Success', `Review Type ${message}!`, 'success')
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
